import * as React from 'react';
import Svg, { SvgProps, Path } from 'react-native-svg';

const NfcIcon = (props: SvgProps) => (
  <Svg
    width={33}
    height={32}
    fill="none"
    {...props}
  >
    <Path
      stroke="#0058AD"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M11.417 8H4.75c-.736 0-1.333.597-1.333 1.333v13.334c0 .736.597 1.333 1.333 1.333h6.667c.736 0 1.333-.597 1.333-1.333V9.333c0-.736-.597-1.333-1.333-1.333ZM18.084 11.094a9.906 9.906 0 0 1 0 9.813M22.697 8.28a15.68 15.68 0 0 1 0 15.44m4.6-18.253a21.213 21.213 0 0 1 .013 21.067"
    />
  </Svg>
);
export default NfcIcon;
